import { render, staticRenderFns } from "./UserEditPersonalForm.vue?vue&type=template&id=5659356a&scoped=true"
import script from "./UserEditPersonalForm.vue?vue&type=script&lang=js"
export * from "./UserEditPersonalForm.vue?vue&type=script&lang=js"
import style0 from "./UserEditPersonalForm.vue?vue&type=style&index=0&id=5659356a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5659356a",
  null
  
)

export default component.exports